module.exports = __webpack_public_path__ + "img/Kuwait.831e9a1c.png";